module.exports = __webpack_public_path__ + "img/HCZ2.68a15dc1.jpg";